import React, { useEffect } from 'react';
const TermsAndConditions = () => {
    useEffect(() => {
        document.title = "Terms & Conditions - CGES.CLUB";
    }, []);
    return (
        <>

            <div className="breadcrumb-area policy-breadcrumb">
                <div className="container">
                    <div className="breadcrumb-inner">
                        <h2 className="page-title policy-page-title">Terms & <span>Conditions</span></h2>
                        <ul className="page-list">
                            {/* <li><a href="index.html">Home</a></li> */}
                            <li className="policy-effective-date">EFFECTIVE DEC 30, 2024</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="blog-area pd-top-60 policy-page">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="blog-details-page-content">
                                <div className="single-blog-inner style-large">

                                    <div className="details p-0 policy-content">

                                        <p>Welcome to the CGES.club. These Terms of Use (“Agreement”) constitute a legally binding agreement between you (“user”) and the CGES.club website (“we” or “us” or “our”) concerning your use of our website and services. By accessing or using our website, you agree that you have read, understand, and agree to be bound by this Agreement. If you do not wish to be bound by this Agreement, you should not access or use our website.</p>

                                        <br/>
                                        <h4 className="title">1. Use of the Website</h4>
                                        <p>Our website is intended to provide information and services related to the CGES.club. You may use our website only for lawful purposes and in accordance with this Agreement. You agree not to use our website: </p>

                                        <ul>
                                            <li>In any way that violates any applicable federal, state, local, or international law or regulation. </li>
                                            <li>To impersonate or attempt to impersonate the CGES.club, an CGES.club employee, another user, or any other person or entity. </li>
                                            <li>To engage in any other conduct that restricts or inhibits anyone’s use or enjoyment of the website, or which, as determined by us, may harm the CGES.club or users of the website. </li>
                                            <li>To engage in any data mining, harvesting, scraping, or other unauthorized collection of data or personal data. </li>
                                            <li>To introduce any viruses, Trojan horses, worms, logic bombs, or other material that is malicious or technologically harmful. </li>
                                            <li>In any manner that could disable, overburden, damage, or impair the website or interfere with any other party’s use of the website. </li>
                                            <li>To mass-advertise, spam, or solicit other users of the website. </li>
                                        </ul>

                                        <br/>
                                        <h4 className="title">2. Intellectual Property</h4>
                                        <p>All content and materials available on our website, including but not limited to text, graphics, logos, button icons, images, audio clips, and data compilations, are the property of the CGES.club website or its content suppliers and licensors and are protected by Saudi Arabia and international copyright laws. </p>

                                        <br/>
                                        <h4 className="title">3. Disclaimer of Warranties</h4>
                                        <p>Our website is provided on an “as-is” and “as available” basis. The CGES.club makes no representations or warranties of any kind, express or implied, as to the operation of this website or the information, content, materials, or products included on this website. You expressly agree that your use of this website is at your sole risk. </p>

                                        <br/>
                                        <h4 className="title">4. Limitation of Liability</h4>
                                        <p>In no event shall The CGES.club website or its affiliates, officers, directors, employees, agents, or suppliers be liable for any indirect, incidental, special, or consequential damages arising out of or in connection with the use or inability to use our website or services, including but not limited to damages for loss of profits, use, data, or other intangibles, even if the CGES.club has been advised of the possibility of such damages. </p>

                                        <br/>
                                        <h4 className="title">5. Privacy notice</h4>
                                        <p>We respect your privacy and are committed to protecting your personal data. Our Privacy notice governs the collection, use, and disclosure of your personal data. </p>

                                        <br/>
                                        <h4 className="title">6. Changes to this Agreement</h4>
                                        <p>We reserve the right to modify or update this notice at any time, and you agree to be bound by the updated notice. We will notify you of any changes to this Agreement by posting a notice on our website. </p>

                                        <br/>
                                        <h4 className="title">7. Governing Law</h4>
                                        <p> This Agreement will be governed by and construed in accordance with the laws of Saudi Arabia without regard to its conflict of law provisions. </p>

                                        <br/>
                                        <h4 className="title">8. Contact Information</h4>
                                        <p> If you have any questions or concerns about this Agreement or our website or services, please contact us on  <a href='mailto:support@cges.club' className = 'color-base'>info@cges.club </a></p>
        

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TermsAndConditions
